class CartItems extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('update-cart', () => {
      this.updateCart();
    });

    this.attachEvents(); // initial setup
  }

  attachEvents() {
    this.closeButton = this.querySelector('.cart-drawer-close');
    this.closeButton?.addEventListener('click', (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('close-cart'));
    });

    this.querySelectorAll('.cart-item-details-options-remove').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const variantId = button.dataset.id;
        this.updateItem(variantId, 0);
      });
    });

    this.querySelectorAll('.cart-item-details-options-quantity-plus').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const variantId = button.dataset.id;
        this.updateItem(variantId, parseInt(button.dataset.quantity) + 1);
      });
    });

    this.querySelectorAll('.cart-item-details-options-quantity-min').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const variantId = button.dataset.id;
        this.updateItem(variantId, Math.max(0, parseInt(button.dataset.quantity) - 1));
      });
    });
  }

  updateItem(variantId, quantity) {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: variantId, quantity: quantity }),
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then((data) => {
        // send custom event with item_count
        document.dispatchEvent(
          new CustomEvent('inventory-updated', {
            detail: {
              item_count: data.item_count,
            },
          }),
        );
        this.dataset.loading = true;
        this.updateCart();
      })
      .catch((e) => console.error(e));
  }

  updateCart() {
    fetch(window.Shopify.routes.root + 'cart')
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const cartItems = doc.querySelector('.cart-items');
        if (!cartItems) throw new Error('Cart items not found');

        this.innerHTML = cartItems.innerHTML;
        this.dataset.loading = false;

        this.attachEvents(); // re-apply event listeners
        document.dispatchEvent(new CustomEvent('open-cart'));
      })
      .catch((e) => console.error(e));
  }
}

customElements.define('cart-items', CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.dataset.open = false;

    // listen to custom event to open the cart
    document.addEventListener('open-cart', () => {
      this.open();
    });

    // listen to custom event to close the cart
    document.addEventListener('close-cart', () => {
      this.close();
    });

    // listen to custom event to toggle the cart
    document.addEventListener('toggle-cart', () => {
      this.toggle();
    });

    // close cart when clicking on this but not a child of this
    this.addEventListener('click', (e) => {
      if (this.dataset.open === 'true' && this === e.target) {
        e.preventDefault();
        this.close();
      }
    });
  }

  open() {
    this.dataset.open = true;
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.dataset.open = false;
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  toggle() {
    if (this.dataset.open === 'true') {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);
